import { queryOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';

import type {
  StandbyCustomerEntriesQueryKey,
  StandbyCustomerEntriesResponse,
} from './types';

/**
 * Contract: SQR-15489 wire contract (Central Command, 2026-09-10).
 * `GET /v1/standby-list/customer/entries` -> 200 `{ entries: StandbyCustomerEntry[] }`,
 * scoped to the signed-in customer session (no shopId param).
 */
export const standbyCustomerEntriesQuery = (customerId: string) => {
  const fetchCustomerEntries =
    async (): Promise<StandbyCustomerEntriesResponse> => {
      const { data } = await apiClient.get<StandbyCustomerEntriesResponse>(
        '/v1/standby-list/customer/entries',
      );

      return data;
    };

  return queryOptions<
    StandbyCustomerEntriesResponse,
    Error,
    StandbyCustomerEntriesResponse,
    StandbyCustomerEntriesQueryKey
  >({
    queryKey: ['standby', 'customerEntries', customerId],
    queryFn: fetchCustomerEntries,
    enabled: !!customerId,
  });
};
